export enum BUTTONTYPE {
    BUTTON = 'button',
    SUBMIT = 'submit',
    RESET = 'reset'
}